import { isSameDay, isSameMonth, isSameWeek } from 'date-fns';

import { DashboardGranularity } from '__generated__/GQL';

const CURRENT_DATE = new Date();

// We only want to show the dot if the point's date matches the current real date
export const shouldShowCurrentDateDot = (
  granularity: DashboardGranularity,
  pointDateString?: string | null,
) => {
  if (pointDateString === undefined || pointDateString === null) {
    return false;
  }

  const pointDate = new Date(pointDateString);

  if (granularity === DashboardGranularity.Month) {
    return isSameMonth(CURRENT_DATE, pointDate);
  }

  if (granularity === DashboardGranularity.Week) {
    return isSameWeek(CURRENT_DATE, pointDate);
  }

  return isSameDay(CURRENT_DATE, pointDate);
};
